<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card"> 

        
        
        <div class="p-mb-4 p-d-flex p-jc-between p-toolbar">
          <!-- <Button
            label="New Activity Type"
            icon="pi pi-plus"
            class="p-button-success p-mr-2"
            style="margin-right: 1em"
            @click="openNew"
          /> -->
          <div>
            <span class="p-input-icon-left">
              <i class="pi pi-search" />
              <InputText
                v-model="globalFilter"
                placeholder="Global Search"
                style="margin-right: 0.5em"
                @input="updateSearch"
              />
            </span>
          </div>
        </div>
            
        <historyTable
          :data="enquiryHisotry"
          :name="'Enquiry History'"
          :loading="loading"
          :globalFilter="globalFilter"
        />

      </div>
    </div>
  </div>
</template>

<script>
import OpportunityService from "@/service/OpportunityService";

import historyTable from '../../universalComponents/history/historyTable'

export default {
  components: {
    historyTable
  },
  props: ["opportunity"],
  data: () => ({
    opportunityService: new OpportunityService(),
    globalFilter: '',
    enquiryHisotry: []
  }),
  computed: {
    loading() {
      return this.activityHisotry ? false : true
    },
    activityHisotry() {
      return this.$store.getters['activities/getActivityForTabs']
    }
  },
  created() {

    if (this.$route.query.search !== '') {
      this.updateSearch('')
    }
    this.opportunityService
      .getEnquiryHistory(this.opportunity.oppId)
      .then(data => this.enquiryHisotry = data)
      .catch(err => {
        
              
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting Enquiry History",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "recordHistoryEnquiry/{oppId}"'
        })
      })
  },
  methods: {
    updateSearch(e) {
      this.$router.push({ query: { search: e } });
    },
  }
}
</script>

<style>

</style>